<template>
  <div>
    <vx-card>
      <div class="flex justify-between">
        <div></div>
        <vs-button style="margin-left: auto" @click="popupAdd = true" v-if="checkButtonPermission('expertise_add')">
          {{ $t('add') }}
        </vs-button>
      </div>

    </vx-card>
    <div class="mt-3 flex gap-3 flex-wrap">
      <div class="box__card " style="position: relative" v-for="item in GET_EXPERTISES.data" :key="item.id"
           @click="$router.push(`/expertise/${item.id}`)" v-if="checkButtonPermission('expertise_card')">

        <div style="position: absolute;display: flex;top:10px;right: 10px">
          <vs-button
            class="mr-2"
            color="success"
            type="filled"
            v-if="checkButtonPermission('expertise_card_sel')"
            @click.stop="$router.push(`/expertise/details/${item.id}`)"
          >{{ $t("choose") }}
          </vs-button>
          <vs-button
            class="mr-2"
            color="warning"
            type="filled"
            icon="edit"
            v-if="checkButtonPermission('expertise_card_e')"
            @click.stop="editExpertise(item)"
          >
          </vs-button>
          <vs-button
            class="mr-2"
            color="danger"
            icon-pack="feather"
            type="filled"
            icon="icon-trash"
            v-if="checkButtonPermission('expertise_card_d')"
            @click.stop="popupDelete = true; deleteId= item.id "
          >
          </vs-button>
        </div>
        <h4 class="box__card__title-center">{{ item.title[$i18n.locale] }}</h4>
      </div>
    </div>
    <vc-popup
      :title="$t('Add')"
      :active.sync="popupAdd"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">

          <vs-tabs
            bg-color="primary"
          >

            <vs-tab value="one" label="UZ">
              <vs-input v-model="formDataGroup.title.uz" class="w-full">
              </vs-input>
              <p v-if="!formDataGroup.title.uz && addActivate" style="color: red">
                {{ $t('This field is required') }}</p>
            </vs-tab>
            <vs-tab value="two" label="RU">
              <vs-input v-model="formDataGroup.title.ru" class="w-full">
              </vs-input>
              <p v-if="!formDataGroup.title.uz && addActivate" style="color: red">
                {{ $t('This field is required') }}</p>
            </vs-tab>
          </vs-tabs>

        </div>
        <div class="vx-col w-full flex-end mb-2 text-right h-50">
          <vs-button
            @click="submitAddExpirtise"
            color="primary"
            type="filled"
            class="mt-5"
          >{{ $t('save') }}
          </vs-button>
          <vs-button
            @click="popupAdd = false"
            color="warning"
            type="border"
            class="ml-5"
          >{{ $t('cancel') }}
          </vs-button
          >
        </div>
      </div>
    </vc-popup>
    <!-- модалка для добавления группы  -->
    <!-- модалка для изменения группы  -->
    <vc-popup
      class="holamundo"
      :title="$t('Change')"
      :active.sync="popupEdit"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-tabs
            bg-color="primary"
          >
            <vs-tab value="one" label="UZ">
              <vs-input v-model="formEditGroup.title.uz" class="w-full">
              </vs-input>
              <p v-if="!formEditGroup.title.uz " style="color: red">{{ $t('This field is required') }}</p>
            </vs-tab>
            <vs-tab value="two" label="RU">
              <vs-input v-model="formEditGroup.title.ru" class="w-full">
              </vs-input>
              <p v-if="!formEditGroup.title.ru" style="color: red">{{ $t('This field is required') }}</p>
            </vs-tab>
          </vs-tabs>
        </div>

        <div class="vx-col w-full flex-end mb-2 text-right h-50">
          <vs-button
            @click="submitEditGroup"
            color="primary"
            type="filled"
            class="mt-5"
          >{{ $t('save') }}
          </vs-button>
          <vs-button
            @click="popupEdit = false"
            color="warning"
            type="border"
            class="ml-5"
          >{{ $t('cancel') }}
          </vs-button
          >
        </div>
      </div>
    </vc-popup>
    <!-- модалка для изменения группы  -->
    <!-- модалка для удаления группы  -->
    <vc-popup
      class="holamundo"
      :title="$t('delete')"
      :active.sync="popupDelete"
    >
      <div>
        <p>{{ $t('modules.backups.delete') }}</p>
      </div>
      <div class="vx-col w-full flex-end mb-2 text-right h-50">
        <vs-button
          @click="submitDeleteGroup"
          color="danger"
          type="filled"
          class="mt-5"
        >{{ $t('modules.backups.delete') }}
        </vs-button>
        <vs-button
          @click="popupDelete = false"
          color="warning"
          type="border"
          class="ml-5"
        >{{ $t('cancel') }}
        </vs-button
        >
      </div>
    </vc-popup>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      addActivate: false,
      editActivate: false,
      popupAdd: false,
      popupEdit: false,
      popupDelete: false,
      deleteId: null,
      formDataGroup: {
        title: {
          ru: '',
          uz: ''
        }
      },
      formEditGroup: {
        title: {
          ru: '',
          uz: ''
        }
      }
    };
  },
  computed: {
    ...mapGetters('admin', ['GET_EXPERTISES'])
  },


  async mounted() {
    await this.FETCH_EXPERTISE({page_size: 10000})
  },
  watch: {
    "popupAdd"(val) {
      if (!val) {
        this.addActivate = false
        this.formDataGroup.title.ru = ''
        this.formDataGroup.title.uz = ''
      }
    },
    "popupEdit"(val) {
      if (!val) {
        this.editActivate = false
      }
    }

  },
  methods: {
    ...mapActions('admin', ['CREATE_EXPERTISE', 'FETCH_EXPERTISE', 'PATCH_EXPERTISE', 'DELETE_EXPIRTISE']),
    editExpertise(item) {
      this.popupEdit = true;
      this.formEditGroup.id = item.id
      this.formEditGroup.title.ru = item.title.ru
      this.formEditGroup.title.uz = item.title.uz
    },
    async submitAddExpirtise() {
      this.addActivate = true
      if (this.formDataGroup.title.ru && this.formDataGroup.title.uz) {
        await this.CREATE_EXPERTISE(this.formDataGroup)
        await this.FETCH_EXPERTISE({page_size: 10000})
        this.popupAdd = false
      }

    },
    async submitEditGroup() {
      this.editActivate = true
      if (this.formEditGroup.title.ru && this.formEditGroup.title.uz) {
        await this.PATCH_EXPERTISE(this.formEditGroup)
        await this.FETCH_EXPERTISE({page_size: 10000})
        this.popupEdit = false
      }

    },
    async submitDeleteGroup() {
      await this.DELETE_EXPIRTISE(this.deleteId)
      await this.FETCH_EXPERTISE()
      this.popupDelete = false
    }
  },
};
</script>

<style>
.box__card {
  width: 310px;
  height: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF;
  border-radius: 3%;
  cursor: pointer;

  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.box__card__title-center {
  font-size: 20px;
  padding: 0 10px;
  word-break: break-all;
  white-space: break-spaces;
  text-align: center;
}
</style>
